import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { Checkbox } from 'ui-components/components/checkbox';
import { Pill } from 'ui-components/components/pill';
import { noop } from 'ui-components/default-props/noop';

import { TagPropType } from '../../prop-types/tag';

import style from './tag-dropdown.module.less';

export const TagDropdownItem = ({ tag, isChecked, onTagToggled, className }) => {
  const onClick = useCallback(() => onTagToggled(tag), [tag, onTagToggled]);

  return (
    <DropdownMenuItem className={classnames(style['dropdown-menu-item'], className)} onClick={onClick}>
      <Checkbox checked={isChecked} className={style.checkbox} onChange={noop} />
      <Pill className={style.pill} color={tag.hexColor} label={tag.name} theme='no-status' />
    </DropdownMenuItem>
  );
};

TagDropdownItem.propTypes = {
  tag: TagPropType.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onTagToggled: PropTypes.func.isRequired,
  className: PropTypes.string,
};
